<template>
    <span class="text-danger">
        <i
            class="fa fa-times-circle fa-lg icon-button mr-1"
            title="Reprovar"
            @click.stop="confirmarReprovar()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarReprovar() {
            this.$swal({
                title: 'Reprovar Serviço',
                html: `Confirma a reprovação da serviço <b>${this.comprometimento.idComprometimento}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a justificativa`,
                inputValidator: value => {
                    if (!value) {
                        return `A justificativa é obrigatória'`
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovar(result.value)
                }
            })
        },

        reprovar(justificativa) {
            this.$store.dispatch('addRequest')
            this.dataServico
                .reprovarComprometimento({
                    idComprometimento: this.comprometimento.idComprometimento,
                    justificativa: justificativa
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Serviço reprovado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obter-atualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao reprovar serviço!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
